// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__efv0g","colBig":"styles_colBig__23xG9","colSmall":"styles_colSmall__1gyk3","shopifyNameWrapper":"styles_shopifyNameWrapper__1b3oj"};